module.exports = __webpack_public_path__ + "img/card.2550407f.png";